<template>
    <simple-dropdown
        class="pointer-events-auto"
        position="right"
    >
        <template #trigger>
            <simple-button
                display="neutral"
                icon="more-vert"
                look="icon"
                small
            />
        </template>

        <template #content="{ close }">
            <nav
                aria-orientation="vertical"
                class="bg-white relative rounded shadow"
                role="menu"
            >
                <dropdown-item
                    icon="content-copy"
                    :input-label="$t('multi-posting.campaigns.duplicate.label')"
                    @click="duplicateCampaign(); close();"
                />
                <dropdown-item
                    v-if="isOnline"
                    icon="statistics"
                    :input-label="$t('multi-posting.campaigns.view_analytics.label')"
                    @click="viewAnalytics(); close();"
                />
                <dropdown-item
                    :disabled="onlyHasSocialChannels || !isOnline"
                    icon="cancel"
                    :input-label="$t('multi-posting.campaigns.take_offline')"
                    @click="takeOffline(); close();"
                />
                <dropdown-item
                    v-if="isDraft"
                    danger
                    icon="delete"
                    :input-label="$t('multi-posting.campaigns.delete_draft.label')"
                    @click="deleteDraft(); close();"
                />
            </nav>
        </template>
    </simple-dropdown>
</template>

<script>
import SimpleDropdown from "../ui/SimpleDropdown.vue";
import SvgIcon from "../ui/SvgIcon.vue";
import SimpleButton from "../ui/SimpleButton.vue";
import DropdownItem from "../ui/DropdownItem.vue";

export default {
    components: {DropdownItem, SimpleButton, SimpleDropdown, SvgIcon},
    props: {
        campaign: Object
    },
    computed: {
        isOnline() {
            return this.campaign.status === "online"
        },
        isDraft() {
            return this.campaign.draft_mode
        },
        onlyHasSocialChannels() {
            return this.campaign.channels.length > 0 && this.campaign.channels.every(ch => ch.type === "socialChannel")
        }
    },
    methods: {
        addNewFromThis() {
            this.$emit("add-new-from-this", this.campaign)
        },
        viewAnalytics() {
            this.$emit("view-anayltics", this.campaign)
        },
        takeOffline() {
            this.$emit("offline-campaign", this.campaign)
        },
        deleteDraft() {
            this.$emit("delete-draft", this.campaign)
        },
        duplicateCampaign() {
            this.$emit("duplicate-campaign", this.campaign)
        }
    }
}
</script>
